import { Fetch } from 'lib';
import type { ProductComment } from 'types';

type RequestResponses = ProductComment;

type RequestParameters = {
  id: string;
};

const getProductComment = async (params: RequestParameters) =>
  await Fetch<RequestResponses, RequestParameters>({
    url: 'adminProductComment/getProductComment',
    params,
  });

export { getProductComment };
